
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/evaluation",
      function () {
        return require("private-next-pages/profile/evaluation.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/evaluation"])
      });
    }
  